import React from "react";
import SecondaryHeader from "../../components/SecondaryHeader/SecondaryHeader";
import ChooseLocation from "../../components/PatrolBarcodeComponent/ChooseLocation";
const ShiftChoose: React.FC = () => {
  return (
    <div>
      <SecondaryHeader title="Absen" pathname="/home" />
      <ChooseLocation />
    </div>
  );
};

export default ShiftChoose;
